import $axios from '@/core/api.service'

class GeneralService {
  // get user data
  getUserData () {
    return $axios.get('/api/users')
  }

  // get countries
  getCountries (value) {
    return $axios.get(`/api/country${value ? `?search=${value}` : ''}`)
  }

  // get provinces
  getProvinces (value) {
    return $axios.get(`/api/province${value ? `?search=${value.search}&country_id=${value.countryId}` : ''}`)
  }

  // get all activities
  getActivities () {
    return $axios.get('/api/notifications/activity')
  }

  // get all notifications
  getNotifications () {
    return $axios.get('/api/notifications')
  }

  // set viewed notifications
  setViewedNotifications () {
    return $axios.get('/api/notifications/set_viewed')
  }

  getHelpTypes () {
    return $axios.get('/api/help/types')
  }

  getHelpTypesSubjects (typeId) {
    return $axios.get(`/api/help/types/${typeId}/subjects`)
  }

  sendRequest (data) {
    return $axios.post('/api/help', data)
  }
}

export default new GeneralService()
